import { logger } from '@gem/modules/logger';

import { IUserDeviceKeyPackages } from 'APP/model/e2ee/e2eeModel.types';
import { buildModelError } from 'APP/model/error/errorBuilder';
import { e2eeModel } from 'APP/model/model';

export const getKeyPackages = async (membersIds: string[]): Promise<IUserDeviceKeyPackages> => {
  try {
    return await e2eeModel.consumeKeyPackages(membersIds);
  } catch (error) {
    logger.get('Tasks').error('e2ee.getKeyPackages', error);
    throw buildModelError(error);
  }
};
